import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { setAuthorization, TokenManager } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props : any) =>{
  const dispatch : any = useDispatch();
  const { userProfile, loading, token } = useProfile();
  
  useEffect(() => {
    const refreshToken = TokenManager.getRefreshToken();
    if (refreshToken && TokenManager.isRefreshTokenExpired()) {
      dispatch(logoutUser());
      return;
    }

    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!token && !loading) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  if (!token) {
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return <>{props.children}</>;
};


export default AuthProtected;